const ITEM_TYPE = {
  HEADER: 'header',
  SUBHEADER: 'subheader'
};

const NO_SUBSCRIPTION = 'no_subscription';

const PERIODICITIES = {
  BIANNUAL: 'biannual',
  ANNUAL: 'annual',
  SEMESTER: 'semester',
  QUARTERLY: 'quarterly',
  BIMONTHLY: 'bimonthly',
  MONTHLY: 'monthly',
  WEEKLY: 'weekly',
  SINGLE_INSTALLMENT: 'single_installment'
};

export { ITEM_TYPE, NO_SUBSCRIPTION, PERIODICITIES };
